<!-- Footer -->
<div class="navbar navbar-expand-lg navbar-light">
    <div class="text-center d-lg-none w-100">
        <button type="button" class="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-footer">
            <i class="icon-unfold mr-2"></i>
            Footer
        </button>
    </div>
    <div class="navbar-collapse collapse" id="navbar-footer">
        <span class="navbar-text">
            &copy; 2018 - {{ currentYear }}. <a href="/">{{ _settings.footer_text }} </a>
            <span *ngIf="_settings.powered_by_title">
                by <a href="#" target="_blank">{{ _settings.powered_by_title }}</a>
            </span>
        </span>
    </div>
</div>